class AbstractState {
  constructor(rangeResolver) {
    this.selectedFeatures = []
    this.rangeResolver = rangeResolver
  }

  isFeatureSelected(featureId, isFirst) {
    const selectedIndex = this.selectedFeatures.findIndex(
      (f) => f === featureId
    )
    return selectedIndex !== -1 && !(isFirst && selectedIndex !== 0)
  }
  hasSelection() {
    return this.selectedFeatures && this.selectedFeatures.length > 0
  }
  getSelected() {
    return this.selectedFeatures
  }
  getInitial() {
    return new NotSelectedState(this.rangeResolver)
  }
}

class NotSelectedState extends AbstractState {
  transitionStateWith(featureId) {
    return new SelectedFirstState(this, featureId)
  }
}

class SelectedFirstState extends AbstractState {
  constructor(state, featureId) {
    super(state.rangeResolver)
    this.selectedFeatures = [featureId]
  }
  transitionStateWith(featureId) {
    // Do not select range if the same feature is about to be selected
    if (
      !this.selectedFeatures.length ||
      this.selectedFeatures[0] === featureId
    ) {
      return this
    }
    return new SelectedRangeState(this, featureId)
  }
}

class SelectedRangeState extends AbstractState {
  constructor(state, featureId) {
    super(state.rangeResolver)
    this.selectedFeatures = state.rangeResolver.resolve(
      state.selectedFeatures,
      featureId
    )
  }
  transitionStateWith(featureId) {
    return new SelectedFirstState(this, featureId)
  }
}

class RangeResolver {
  constructor(storyService, story) {
    this.storyService = storyService
    this.story = story
  }

  resolve(arrayOfIds, secondId) {
    if (!arrayOfIds || arrayOfIds.length === 0) {
      return [secondId]
    }
    const [firstId] = arrayOfIds
    const isOneOff = (id) => id === firstId || id === secondId
    const positions = this.storyService.getContentElementPositions()
    return positions.reduce((acc, position) => {
      const isOnBoundary = isOneOff(position)
      if (acc.inBetween) {
        acc.result.push(position)
        if (isOnBoundary) {
          acc.inBetween = false
        }
      } else if (isOnBoundary) {
        acc.inBetween = true
        acc.result = [position]
      }
      return acc
    }, {}).result
  }
}

export function notSelectedState(storyService, story) {
  const rangeResolver = new RangeResolver(storyService, story)
  return new NotSelectedState(rangeResolver)
}
